module.exports = __webpack_public_path__ + "img/xiaonan_20210901114813.18826daf.png";